import { createSelector, select } from '@ngrx/store';
import { pipe } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { User } from '@shared/models';

import { collectionsConfig } from '../collections.config';
import { CollectionsState, getCollectionsState } from '../collections.reducer';
import { usersAdapter, UsersState } from './users.reducer';

export const getUsersState = createSelector(
  getCollectionsState,
  (state: CollectionsState) => !!state && state.users,
);

export const {
  selectIds: getUsersIds,
  selectEntities: getUsersEntities,
  selectAll: getUsersAll,
  selectTotal: getUsersTotal,
} = usersAdapter.getSelectors(getUsersState);

export const getUsersLoggedIn = createSelector(
  getUsersState,
  (state: UsersState) => state.loggedInUser,
);

export const getUser = createSelector(
  getUsersEntities,
  (entities, props) => !!entities && entities[props.id],
);

export const getUsersMentions = createSelector(getUsersAll, (users: User[] = []) =>
  users.map(
    (user: User) =>
      !!user && {
        id: user.shortName,
        value: `${user.firstName} ${user.lastName}`,
      },
  ),
);

export const hasAnonymization = createSelector(
  getUsersLoggedIn,
  (user: User) => !!user && user.anonymization,
);

export const getCurrentUserPrivileges = createSelector(
  getUsersLoggedIn,
  (user: User) => user?.resources,
);

export const isCurrentUserHiringManager = createSelector(
  getCurrentUserPrivileges,
  (userPrivileges) =>
    !!userPrivileges && userPrivileges.includes(collectionsConfig.privileges.hiringManager),
);

export const isPrivilegesLoaded = pipe(
  select(getUsersLoggedIn),
  filter((user) => !!user),
  map((user) => !!user),
);
